/**
 * For handling unrelated links inside a turbo-frame container
 * Reference: https://github.com/hotwired/turbo/pull/863#issuecomment-1499571361
 */
document.addEventListener('turbo:frame-missing', function (event) {
  event.preventDefault()
  event.detail.visit(event.detail.response)
})
